import * as React from 'react';
export const elevenlabsSvg = React.forwardRef(function elevenlabsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.26 5h4.52v22h-4.52V5ZM9.22 5h4.52v22H9.22V5Z',
      fill: '#000',
    }),
  );
});
elevenlabsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var elevenlabs = {
  category: 'brand',
  colorable: false,
  name: 'elevenlabs',
  svg: elevenlabsSvg,
};
